import React, { useState } from 'react';
import { useGlobalValue } from '../../state/GlobalProvider';
import styles from './ExpandableWidget.module.sass';

const ExpandableWidget = props => {
  const {
    title,
    children,
    className
  } = props;
  const [expanded, setExpanded] = useState(false);
  const {
    i18n
  } = useGlobalValue();
  const actionLabel = expanded ? i18n`Hide` : i18n`Show`;
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles['root']} ${className} ${expanded ? '' : styles['collapsed']}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `widget-title ${styles['header']}`,
    onClick: () => {
      setExpanded(!expanded);
    }
  }, /*#__PURE__*/React.createElement("h5", {
    className: styles['title']
  }, title), /*#__PURE__*/React.createElement("button", {
    className: styles['button']
  }, /*#__PURE__*/React.createElement("small", null, actionLabel))), expanded && children);
};

export default ExpandableWidget;